import { createDataHook } from 'next-data-hooks';
import { InstanceMeta } from '../models/instanceMeta';
import InstancesService from '../services/instances.service';

export const useInstanceMetaByUrlSsr = createDataHook<InstanceMeta>(
    'instance-meta-by-url', async (context) => {
        const instanceId = context?.params?.instanceId as unknown as number

        if(!instanceId) return null

        const instanceService = new InstancesService();
        const instanceResponse = await instanceService.getInstancesById(instanceId)        
        const instanceMetaResponse = await instanceService.getJsonMetaDataByMetaUrl(instanceResponse.data.metaUrl!)

        return instanceMetaResponse
    }
);
